export const FETCH_TEST = 'fetch/FETCH_TEST';
export const FETCHING_TEST = 'fetch/FETCHING_TEST';
export const FETCHED_TEST = 'fetch/FETCHED_TEST';